import Vue from 'vue'
import {
  URL_USER,
  URL_USER_LOGON,
  URL_USER_ADMIN_LOGON,
  URL_USER_CHANGE_PASSWORD,
  URL_USER_VERIFY,
  URL_USER_RESET_PASSWORD,
  URL_USER_RESET_PASSWORD_CONFIRMED
} from '@/constants/urls.js'
import { LOCAL_STORE_NAMES } from '@/constants/settings.js'
import {
  ACCOUNT, ERRORS, AXIOS_REQUESTS,
  CURRENT_USER, CURRENT_USER_EXPIRATIONS_DATES
} from '@/constants/store.js'

// import persistance from '@/utils/persistStatesHelper'

const initState = () => {
  const fromLocalStorage = Vue.helpers.getFromLocalStorage(LOCAL_STORE_NAMES.USER)
  if (fromLocalStorage) {
    return {
      isLoggedIn: fromLocalStorage.isLoggedIn || false,
      token: fromLocalStorage.token || null,
      participantType: fromLocalStorage.participantType || null,
      userName: fromLocalStorage.userName || null
    }
  } else {
    return {
      isLoggedIn: false,
      token: null,
      participantType: null,
      userName: null
    }
  }
}

const state = initState()

const actions = {
  async [ACCOUNT.ACTIONS.REGISTER_USER] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_USER}`,
      model
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.POST_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [ACCOUNT.ACTIONS.LOG_IN_USER] ({ dispatch, commit }, account) {
    const model = {
      url: `${Vue.getIdentityHost()}${URL_USER_LOGON}`,
      model: account
    }
    try {
      const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
      commit(ACCOUNT.MUTATIONS.LOGIN_SUCCESS, resp.data)
    } catch (error) {
      commit(ACCOUNT.MUTATIONS.LOGIN_ERROR)
      throw error
    }
  },
  async [ACCOUNT.ACTIONS.LOG_IN_ADMIN] ({ dispatch, commit }, account) {
    const model = {
      url: `${Vue.getIdentityHost()}${URL_USER_ADMIN_LOGON}`,
      model: account
    }
    try {
      const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
      commit(ACCOUNT.MUTATIONS.LOGIN_SUCCESS, resp.data)
    } catch (error) {
      commit(ACCOUNT.MUTATIONS.LOGIN_ERROR)
      throw error
    }
  },
  async [ACCOUNT.ACTIONS.CHANGE_PASSWORD] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_USER_CHANGE_PASSWORD}`,
      model
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(ACCOUNT.MUTATIONS.SET_USER_INFO, {
      name: 'token',
      value: resp.data.token || null
    })
  },
  async [ACCOUNT.ACTIONS.SET_USER_NAME]  ({ commit }, userName) {
    commit(ACCOUNT.MUTATIONS.SET_USER_INFO, {
      name: 'userName',
      value: userName || null
    })
  },
  async [ACCOUNT.ACTIONS.UPDATE_PARTICIPANT_TYPE]  ({ commit }, participantType) {
    commit(ACCOUNT.MUTATIONS.SET_USER_INFO, {
      name: 'participantType',
      value: participantType || null
    })
  },
  async [ACCOUNT.ACTIONS.RELOAD_LOGIN_STATUS_FROM_LOCAL_STORAGE]  ({ commit }) {
    commit(ACCOUNT.MUTATIONS.RELOAD_LOGIN_STATUS_FROM_LOCAL_STORAGE)
  },
  async [ACCOUNT.ACTIONS.CONFIRM_EMAIL] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_USER_VERIFY}`,
      model
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [ACCOUNT.ACTIONS.RESET_PASSWORD] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_USER_RESET_PASSWORD}`,
      model
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [ACCOUNT.ACTIONS.RESET_PASSWORD_CONFIRMED] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_USER_RESET_PASSWORD_CONFIRMED}`,
      model
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [ACCOUNT.ACTIONS.LOG_OUT] ({ commit, dispatch }) {
    commit(ACCOUNT.MUTATIONS.LOG_OUT)
    await dispatch(`${CURRENT_USER.NAMESPACE}/${CURRENT_USER.ACTIONS.CLEAR_CURRENT_USER_INFO}`, null, { root: true })
    await dispatch(`${CURRENT_USER_EXPIRATIONS_DATES.NAMESPACE}/${CURRENT_USER_EXPIRATIONS_DATES.ACTIONS.CLEAR_EXPIRATION_DATES}`, null, { root: true })
    // commit('reset')
  }
}

const mutations = {
  [ACCOUNT.MUTATIONS.RELOAD_LOGIN_STATUS_FROM_LOCAL_STORAGE] (state) {
    const startState = initState()
    if (initState.isLoggedIn !== state.isLoggedIn) {
      Object.keys(startState).forEach((key) => {
        state[key] = startState[key]
      })
    }
  },
  [ACCOUNT.MUTATIONS.LOGIN_ERROR] (state) {
    state.isLoggedIn = false
    state.token = null
    state.participantType = null
  },
  [ACCOUNT.MUTATIONS.SET_USER_INFO] (state, prop) {
    Vue.set(state, prop.name, prop.value)
    Vue.helpers.saveToLocalStorage(LOCAL_STORE_NAMES.USER, null)
    Vue.helpers.saveToLocalStorage(LOCAL_STORE_NAMES.USER, {
      isLoggedIn: true,
      token: state.token,
      participantType: state.participantType,
      userName: state.userName
    })
  },
  [ACCOUNT.MUTATIONS.LOGIN_SUCCESS] (state, model) {
    state.isLoggedIn = true
    state.token = model.token
    state.participantType = model.participantType
    Vue.helpers.saveToLocalStorage(LOCAL_STORE_NAMES.USER, {
      isLoggedIn: true,
      token: state.token,
      participantType: state.participantType,
      userName: state.userName
    })
  },
  [ACCOUNT.MUTATIONS.LOG_OUT] (state) {
    state.token = null
    state.participantType = null
    state.isLoggedIn = false
    state.userName = null
    Vue.helpers.saveToLocalStorage(LOCAL_STORE_NAMES.USER, null)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
